import { Pipe, PipeTransform } from '@angular/core';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';

@Pipe({
  name: 'contentWeather'
})
export class WeatherPipe implements PipeTransform {

  transform(entry: Models.ContentEntry): Models.WeatherEntry | any {
    if (!entry?.detail?.weather?.forecast?.days) {
      return null;
    }

    const forecastDays = entry.detail.weather.forecast.days;
    let days = [];
    let extendVersion = false;
    let today = new Date();
    let hourNow = (Math.min(today.getHours(), 15).toString().length === 1 ? '0' + Math.min(today.getHours(), 15)
      .toString() : Math.min(today.getHours(), 15).toString()) + ':00';
    today = this.nullTime(today);

    for (const day in forecastDays) {

      if (!forecastDays.hasOwnProperty(day)) {
        continue;
      }

      const forecast = forecastDays[day];

      if (new Date(day).getTime() - today.getTime() < 0 || Object.keys(forecast).length === 0) {
        continue;
      }

      const entryWeatherDay = new Models.WeatherDayEntry();
      entryWeatherDay.populateFromJSON({
        timestamp: new Date(day).getTime() / 1000,
        sunriseTimestamp: parseFloat(forecast.sunrise) || 0,
        sunsetTimestamp: parseFloat(forecast.sunset) || 0,
        sunHours: (parseFloat(forecast.sun) >= 24 ? parseFloat(forecast.sun) / 60 : parseFloat(forecast.sun)).toFixed(1) || 0,
        windSpeed: parseFloat(forecast.ffkmh).toFixed(1) || 0,
        windDirection: forecast.ddcompass,
        windDirectionDegrees: parseFloat(forecast.dd).toFixed(1) || 0,
        rainAmount: parseFloat(forecast.rrr).toFixed(1) || 0,
        probabilityOfPrecipitation: parseFloat(forecast.prrr).toFixed(1) || 0,
        symbolURL: forecast.wwsymbol_mg2008,
        minDegrees: parseFloat(forecast.tn).toFixed(1) || 0,
        maxDegrees: parseFloat(forecast.tx).toFixed(1) || 0
      });

      if (forecast.intervals && !forecast.hourly) {

        let intervals: Models.WeatherIntervalEntry[] = [];

        for (const interval of forecast.intervals) {
          const intervalEntry = new Models.WeatherIntervalEntry();
          intervalEntry.populateFromJSON({
            fromTimestamp: this.convertToUTC(interval.datetime).getTime() / 1000,
            toTimestamp: this.convertToUTC(interval.datetimeend).getTime() / 1000,
            symbolURL: interval.wwsymbol_mg2008,
            degrees: parseFloat(interval.tt).toFixed(1) || 0
          });
          intervals.push(intervalEntry);
        }

        // show only 4 intervals
        if (intervals.length >= 5){
          intervals = intervals.slice(0, 4);
        }
        //
        entryWeatherDay.intervals = intervals;
      }

      if (forecast.hourly && forecast.hourly.airTemp) {
        extendVersion = true;
        let hoursKey = Object.keys(forecast.hourly.airTemp);
        let hoursArr = [];
        for (const hour of hoursKey) {
          let hoursObj = {
            time: hour,
            degrees: forecast.hourly.airTemp[hour],
            symbolURL: forecast.hourly.icon[hour],
            rainAmount: parseFloat(forecast.hourly.liquidAccPeriod[hour]).toFixed(1) || 0,
            probabilityOfPrecipitation: parseFloat(forecast.hourly.precipProb[hour]).toFixed(1) || 0,
            windDirection: forecast.hourly.windDirection[hour],
            windSpeed: forecast.hourly.windSpeed[hour],
          };
          hoursArr.push(hoursObj);
        }
        let weatherDay = this.nullTime(new Date(day));
        if (weatherDay.getTime() !== today.getTime()) {
          hourNow = '00:00';
        }
        let hourIndex = hoursArr.findIndex(el => el.time === hourNow);
        if (hourIndex !== -1) {
          hoursArr = hoursArr.slice(hourIndex, hoursArr.length);
        }
        entryWeatherDay.hours = hoursArr;
      }

      days.push(entryWeatherDay);
    }

    if (days.length === 0) {
      return null;
    }

    days = _.orderBy(days, 'timestamp', 'asc');
    return { sourceId: entry._id, days, extendVersion };
  }

  nullTime(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }

  convertToUTC(dateStr) {
    const dateWithoutTimezone = dateStr.replace('Z', '');
    const date = new Date(dateWithoutTimezone);
    return date;
  }

}
